import React from 'react';
import { browserHistory } from 'react-router';

function withAuthControl(WrappedComponent) {

    return class extends React.Component {

        componentDidMount() {
            const jwtToken = sessionStorage.getItem('jwtToken');
            const endpoint = sessionStorage.getItem('endpoint');
            if (jwtToken === null || endpoint === null){
                browserHistory.push('/');
            } else {
                if (endpoint !== this.props.location.pathname) {
                    browserHistory.push(endpoint);
                }
            }

        }

        render() {
          return <WrappedComponent {...this.props} />;
        }
    };
}

export default withAuthControl;


/** WEBPACK FOOTER **
 ** ./src/auth/Auth.js
 **/